import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DEVHOST, OptionType } from 'src/app/core/enums/enums';
import { PassengerQuote } from 'src/app/core/models/itinerary.model';
import { LayoutService } from 'src/app/layout/services/layout.service';

@Component({
  selector: 'app-instruction-message-action-selected',
  templateUrl: './instruction-message-action-selected.component.html'
})
export class InstructionMessageActionSelectedComponent implements OnInit, OnDestroy {
  @Input() hasPendingChanges: boolean;
  @Input() somePassengerHasTicket: boolean;
  @Input() set selectedMode(value: OptionType) {
    this.mode = value;
    this.validateReceivedFromValue();
  }
  @Input() set selectedPassengersQuote(value: PassengerQuote[]) {
    this.passengers = value;
    this.validateReceivedFromValue();
  }
  @Input() set selectedSegments(value: number[]) {
    this.segments = value;
    this.validateReceivedFromValue();
  }

  private subscriptions = new Subscription();

  isDevelop: boolean = false;
  message = 1;
  mode = '';
  passengers = [];
  segments = [];
  receivedFromHasValue: boolean = false;

  constructor(private layoutService: LayoutService) {}

  ngOnInit(): void {
    this.isDevelop = window.location.host.includes(DEVHOST.host);
    this.callComponentSubcriptions();
  }

  callComponentSubcriptions(): void {
    this.subscriptions.add(
      this.layoutService.getReceivedFrom().subscribe((value) => {
        value ? (this.receivedFromHasValue = true) : (this.receivedFromHasValue = false);
        this.validateReceivedFromValue();
      })
    );
  }

  validateReceivedFromValue() {
    this.isDevelop ? (this.receivedFromHasValue = true) : null;
    this.receivedFromHasValue ? (this.message = this.isMessage()) : (this.message = 7);
  }

  isMessage(): number {
    if (!this.somePassengerHasTicket) {
      return 0;
    }
    if (!this.mode) {
      return 1;
    }
    if (this.canSelectPassengerAndItinerary() && this.haveSegmentsAndPassengers()) {
      return 5;
    }
    if (this.canSelectPassengerAndItinerary()) {
      return 2;
    }
    if (this.mode === OptionType.OpenTicket && this.haveSegmentsAndPassengers()) {
      return 5;
    }
    if (this.mode === OptionType.InvoluntaryChange && !this.hasPendingChanges) {
      return 6;
    }
    if (
      this.mode === OptionType.InvoluntaryChange &&
      this.hasPendingChanges &&
      this.haveSegmentsAndPassengers()
    ) {
      return 5;
    }
  }

  canSelectPassengerAndItinerary() {
    return !(this.mode === OptionType.OpenTicket || this.mode === OptionType.InvoluntaryChange);
  }

  haveSegmentsAndPassengers() {
    return (
      !!this.segments && this.segments.length > 0 && !!this.passengers && this.passengers.length > 0
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
